import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsNamecheapComponent } from './simple-icons-namecheap.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsNamecheapComponent ],
    exports:      [ SimpleIconsNamecheapComponent ],
    bootstrap:    []
})
export class SimpleIconsNamecheapModule {}
